export default __webpack_public_path__ + "static/media/sample-group-profile.0a347fe1.svg";